import React, { Component } from 'react'

import { orderBy, get } from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { submit, formValueSelector } from 'redux-form'

import uberFacts from '../../../../../assets/usageTips/tips.json'
import BlankCard from '../../../../../components/ui/cards/BlankCard'
import LottieLoader from '../../../../../components/ui/lotties/LottieLoader'
import SearchHistoryPanel from '../../../../../components/ui/SearchHistory/SearchHistoryPanel/SearchHistoryPanel'
import selectors from '../../../../../store/shared/selectors'
import { pickWithDefaults } from '../../../../../utils/data'
import withCareers from '../../../../../utils/graphql/hocs/withCareers'
import notificationsUtils from '../../../../../utils/notifications/notificationsUtils'

import * as careerDuck from './careerDuck'
import CareerSearchForm from './components/CareerSearchForm'
import DataComponent from './components/DataComponent'
import Recommendations from './components/Recommendations'
import SavedCareerSearchesWrapper from './components/SavedCareerSearches/savedCareerSearchesWrapper'
import * as savedCareerSearchesDuck from './savedCareerSearchesDuck'

const resultHeaders = [
  {
    header: 'Average Salary & Outlook',
  },
  {
    header: 'Common Jobs',
    tipContent:
      'Here are some common jobs based on your search. Do any of these jobs sound like fun?',
  },
  {
    header: 'Top Companies',
    tipContent: 'These are the most common companies hiring for this major.',
  },
]

class AuthenticatedSearchCareerIndex extends Component {
  constructor(props) {
    super(props)

    this.defaultCareersData = {
      careerPathData: [],
      commonJobSalary: [],
      degreeDrilldown: {},
      highestPayingJobData: {},
      predictedSalary: 0,
      recommendedCareerSearches: [],
      recommendedEducationSearches: [],
      relatedSalaryData: {},
      searchClassification: {},
      skills: [],
      topCompanies: [],
      topJobsSalary: 0,
      totalSearchMatches: 0,
      yearsToPosition: 0,
    }

    this.state = {
      firstRenderWithData: false,
    }

    this.saveCareerSearch = () => {
      this.props
        .performSaveCareerSearch({
          searchParams: Object.assign({}, this.props.searchFormValues),
        })
        .then(() => notificationsUtils.showSuccessNotification('Saved Results Successfully!'))
    }

    this.handleFormSubmit = e => {
      if (e && e.preventDefault) {
        e.preventDefault()
      }
      const { searchFormValues } = this.props
      if (this.state.firstRenderWithData) this.setState({ firstRenderWithData: false })
      this.props.getCareersData(searchFormValues)
    }

    this.addCompanyToSearch = companyName => {
      const { setCompanyValue, getCareersData } = this.props
      const newSearchTerms = {
        ...this.props.searchFormValues,
        ...{ company: companyName },
      }

      setCompanyValue(companyName)
      getCareersData(newSearchTerms)
    }
  }

  componentWillMount() {
    const { performRetrieveSavedCareerSearches, userId } = this.props
    performRetrieveSavedCareerSearches({ user_id: userId })
  }

  componentDidMount() {
    const { gaugeMajorData } = this.props
    if (gaugeMajorData.length) this.setState({ firstRenderWithData: true })

    setTimeout(() => {
      const { searchType, search_query } = this.props.queryParams
      if (searchType === 'career' && search_query) {
        this.props.submit('careerSearchForm')
      }
    })
  }

  render() {
    const {
      careersData,
      companyFilter,
      educationInsight,
      gaugeAdvancedData,
      gaugeMajorData,
      isMobile,
      loadingCareersData,
      onChangeResultsPage,
      openModal,
      performDeleteSavedCareerSearch,
      setCareersData,
      queryParams,
      salaryDistribution,
      salaryInsight,
      savedCareerSearches,
      searchError,
      searchTerm,
      titles,
    } = this.props

    const {
      commonJobSalary,
      degreeDrilldown,
      educationBreakdown,
      highestPayingJobData,
      predictedSalary,
      recommendedEducationSearches,
      salaryData,
      searchClassification,
      skills,
      topCompanies,
      topJobsSalary,
      totalSearchMatches,
      yearsToPosition,
    } = pickWithDefaults(careersData, this.defaultCareersData)

    const recommendedCareerSearches = orderBy(topJobsSalary, ['salaryVal'], ['desc'])
      .map(job => job.key)
      .slice(0, 3)

    const commonMajorName = get(careersData, 'mostCommonMajor.category')

    const isEmptyData =
      careersData &&
      typeof careersData === 'object' &&
      (Object.keys(careersData).length === 0 || careersData.totalSearchMatches === 0)

    let pageTitles = null
    if (skills && skills.length > 0) pageTitles = titles
    else {
      pageTitles = [...titles]
      pageTitles.splice(3, 1)
    }
    if (isMobile) pageTitles.splice(2, 1)

    const clearResults = () => {
      setCareersData(this.defaultCareersData)
      this.props.resetFormValues()
    }

    const dataComponent = (
      <DataComponent
        addCompanyToSearch={this.addCompanyToSearch}
        clearResults={clearResults}
        commonJobSalaryData={commonJobSalary}
        educationInsight={educationInsight}
        gaugeAdvancedData={gaugeAdvancedData}
        gaugeMajorData={gaugeMajorData}
        gaugeMajorName={commonMajorName}
        highestPayingJobData={highestPayingJobData}
        isMobile={isMobile}
        saveCareerSearch={this.saveCareerSearch}
        onChangeResultsPage={onChangeResultsPage}
        openModal={openModal}
        pageTitles={pageTitles}
        predictedSalary={predictedSalary}
        recJobs={recommendedCareerSearches}
        recMajors={recommendedEducationSearches}
        resultHeaders={resultHeaders}
        salaryData={salaryData}
        salaryDistribution={salaryDistribution}
        salaryInsight={salaryInsight}
        searchClassification={searchClassification}
        searchTerm={searchTerm}
        skills={skills}
        topCompanies={topCompanies}
        topJobsSalaryData={topJobsSalary}
        totalSearchMatches={totalSearchMatches}
        yearsToPosition={yearsToPosition}
        zoomDegreeData={degreeDrilldown}
        zoomEducationData={educationBreakdown}
      />
    )

    let renderComponent = null
    if (!gaugeMajorData.length && !loadingCareersData && !searchError) {
      renderComponent = (
        <BlankCard notCard noPad delay={0.4}>
          <div style={{ marginTop: '2rem', textAlign: 'center', height: 1 }}>
            <Recommendations handleFormSubmit={this.handleFormSubmit} recType="career" />
          </div>
        </BlankCard>
      )
    } else if (this.state.firstRenderWithData && !isEmptyData && !searchError) {
      renderComponent = dataComponent
    } else {
      renderComponent = (
        <LottieLoader
          height={500}
          width={300}
          isReady={!loadingCareersData}
          animationName="GRADUATE"
          error={searchError}
          noData={isEmptyData}
          uberFacts={uberFacts}
          loadingTime={5000}
          noMessage
          isMobile={isMobile}
          loadingLottieDivMarginTop={-120}
        >
          {dataComponent}
        </LottieLoader>
      )
    }

    return (
      <div>
        <div>
          <div>
            <CareerSearchForm
              enableReinitialize={queryParams.search_query && queryParams.searchType === 'career'}
              initialValues={Object.assign(
                {},
                {
                  search_query: null,
                  company: null,
                  state: [],
                  exact_match: false,
                },
                queryParams.searchType === 'career' ? {search_query: queryParams.search_query, company: queryParams.company, state: queryParams.state ? queryParams.state.split(',') : []} : {},
              )}
              handleSubmit={this.handleFormSubmit}
              isEmptyData={isEmptyData}
              companyFilter={companyFilter}
              isMobile={isMobile}
            />
            {renderComponent}
          </div>
          <SearchHistoryPanel searchFilter="Career">
            <SavedCareerSearchesWrapper
              careerSearches={savedCareerSearches}
              onDelete={performDeleteSavedCareerSearch}
            />
          </SearchHistoryPanel>
        </div>
      </div>
    )
  }
}

const mapStateToProps = () => {
  const getFormValues = selectors.makeGetFormValues()
  const careerSearchFormSelector = formValueSelector('careerSearchForm')
  return state => ({
    companyFilter: state.career.company,
    formValues: careerSearchFormSelector(state, 'search_query', 'company', 'state'),
    isMobile: selectors.isLessThanMedium(state),
    queryParams: selectors.getQueryStringSimply(state),
    savedCareerSearches: savedCareerSearchesDuck.getSavedCareerSearches(state),
    searchFormValues: getFormValues(state.form.careerSearchForm),
    searchTerm: state.career.searchTerm,
    userId: selectors.getUserId(state),
  })
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      performDeleteSavedCareerSearch: savedCareerSearchesDuck.performDeleteSavedCareerSearch,
      performRetrieveSavedCareerSearches:
        savedCareerSearchesDuck.performRetrieveSavedCareerSearches,
      performSaveCareerSearch: savedCareerSearchesDuck.performSaveCareerSearch,
      submit,
      resetFormValues: careerDuck.resetFormValues,
      setCompanyValue: careerDuck.setCompanyValue,
    },
    dispatch,
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withCareers(AuthenticatedSearchCareerIndex))



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/Career/AuthenticatedSearchCareerIndex.js